import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { updateCategoricalExpense, updateTotalExpense } from "../../redux/expenseSlice";
import { addTransactionEntry } from "../../redux/transactionSlice";
import { v4 as uuidv4 } from "uuid";

const ExpenseForm = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  // Initialize with empty strings so that the select value matches the option.
  const [expenseData, setExpenseFormData] = useState({
    name: "",
    amount: "",
    category: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    // Convert numeric values where appropriate.
    setExpenseFormData((prev) => ({
      ...prev,
      [name]: isNaN(Number(value)) ? value : Number(value),
    }));
  };

  const validation = () => {
    const { name, amount, category } = expenseData;
    // Check explicitly for empty strings.
    if (name.trim() === "" || amount === "" || category === "") {
      enqueueSnackbar("Field should not be empty", { variant: "error" });
      return false;
    }
    if (Number(amount) < 0) {
      enqueueSnackbar("Expense amount should not be negative", { variant: "warning" });
      return false;
    }
    return true;
  };

  const newExpenseFormSubmitHandler = (e) => {
    e.preventDefault();

    if (!validation()) {
      return;
    }

    const newAmount = Number(expenseData.amount);

    if (!window.confirm("Do you want to add new Expense?")) {
      return;
    }

    // Update the total and categorical expense slices.
    dispatch(updateTotalExpense({ amount: newAmount, operation: "add" }));
    dispatch(
      updateCategoricalExpense({
        amount: newAmount,
        category: expenseData.category,
        operation: "add",
      })
    );

    // Add a transaction entry with a unique ID.
    const newExpenseData = { ...expenseData, id: uuidv4() };
    dispatch(addTransactionEntry(newExpenseData));

    // Reset the form state.
    setExpenseFormData({
      name: "",
      amount: "",
      category: "",
    });
    
    console.log("done");
  };

  return (
    <>
      <div className="title">New Expense Form</div>
      <form className="expense-form1" onSubmit={newExpenseFormSubmitHandler}>
        <div>
          <label htmlFor="expense-name">Expense Name:</label>
          <input
            type="text"
            name="name"
            id="expense-name"
            value={expenseData.name}
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="expense-amount">Expense Amount:</label>
          <input
            type="number"
            name="amount"
            id="expense-amount"
            value={expenseData.amount}
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="category-select">Select category:</label>
          <select
            name="category"
            id="category-select"
            value={expenseData.category}
            onChange={handleChange}
          >
            <option value="">--Select--</option>
            <option value="food">Food</option>
            <option value="travel">Travel</option>
            <option value="entertainment">Entertainment</option>
            <option value="others">Others</option>
          </select>
        </div>
        <button type="submit">Submit</button>
      </form>
    </>
  );
};

export default ExpenseForm;
